"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageTitle = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _constants = require("../../../constants");
var _JoinComponent = require("../JoinComponent.styled");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/**
 * PageTitle component renders the title for the current page.
 * @param {string} page - Current page identifier
 * @returns {JSX.Element} The title component for the page
 */
var PageTitle = exports.PageTitle = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var page = _ref.page;
  var TitlePageMap = (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _constants.JOIN_PAGE.SETTINGS, 'Settings'), _constants.JOIN_PAGE.SYSTEM_CHECK, 'System Check');
  return /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledCardTitle, {
    tag: "h4"
  }, TitlePageMap[page]);
});
PageTitle.propTypes = {
  page: _propTypes.string.isRequired
};